module.exports = __webpack_public_path__ + "static/img/scene-zjjs.afd5348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene-zjjs.png
// module id = Gz71
// module chunks = 1